/**
 * Which inputs a previewed invoice number was worked out for.
 *
 * The next number depends on the company, the draft it is for, the document
 * type, the format (which picks the series prefix) and the date (which picks the
 * year). While a new preview is being fetched the old one still describes the
 * *previous* inputs, so it must not be shown as if it were the answer to these.
 * Kept free of Svelte imports so the rule can be unit-tested directly.
 */

/** One string per combination of inputs; two calls agree exactly when the inputs do. */
export function previewKey(companyId, draftId, tipoDocumento, formatoTrasmissione, invoiceDate) {
  return JSON.stringify([
    companyId ?? null, draftId ?? null, tipoDocumento ?? null, formatoTrasmissione ?? null,
    invoiceDate instanceof Date ? invoiceDate.toISOString() : (invoiceDate ?? null),
  ]);
}

/**
 * The preview to show for the current inputs, or null while the one held was
 * worked out for other inputs.
 *
 * @param {{key: string, value: object}|null} shown - the last preview and the key it answered
 * @param {string} key - previewKey() of the inputs as they are now
 */
export function currentPreview(shown, key) {
  return shown && shown.key === key ? shown.value : null;
}
